import { useState } from 'react';
import { DataTable } from '@/components/tables';
import { Badge } from '@/components/ui/badge';
import { formatCurrency, formatDate, cn, getStatusColor } from '@/lib/utils';
import { mockPayments } from '@/lib/mock-data';

const columns = [
  {
    accessorKey: 'id',
    header: 'Payment ID',
    cell: ({ row }) => <span className="font-mono font-medium">{row.original.id}</span>,
  },
  {
    accessorKey: 'customer',
    header: 'Customer',
  },
  {
    accessorKey: 'amount',
    header: 'Amount',
    cell: ({ row }) => <span className="font-semibold">{formatCurrency(row.original.amount)}</span>,
  },
  {
    accessorKey: 'method',
    header: 'Method',
    cell: ({ row }) => <Badge variant="secondary">{row.original.method}</Badge>,
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => (
      <Badge className={cn('capitalize', getStatusColor(row.original.status))}>
        {row.original.status}
      </Badge>
    ),
  },
  {
    accessorKey: 'date',
    header: 'Date',
    cell: ({ row }) => formatDate(row.original.date),
  },
];

export default function PaymentsPage() {
  const [payments] = useState(mockPayments);

  const totalReceived = payments
    .filter((p) => p.status === 'completed')
    .reduce((sum, p) => sum + p.amount, 0);

  return (
    <div className="space-y-6" data-testid="payments-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Payments</h1>
          <p className="text-muted-foreground">Track all payment transactions</p>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="p-4 rounded-xl border bg-card">
          <p className="text-sm text-muted-foreground">Total Transactions</p>
          <p className="text-2xl font-bold">{payments.length}</p>
        </div>
        <div className="p-4 rounded-xl border bg-green-50 dark:bg-green-900/20">
          <p className="text-sm text-green-600">Total Received</p>
          <p className="text-2xl font-bold text-green-700">{formatCurrency(totalReceived)}</p>
        </div>
        <div className="p-4 rounded-xl border bg-card">
          <p className="text-sm text-muted-foreground">This Month</p>
          <p className="text-2xl font-bold">{formatCurrency(totalReceived)}</p>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={payments}
        searchPlaceholder="Search payments..."
      />
    </div>
  );
}
